import { normalizeAcademicYear } from "./academicYear";

export const GAME_RESULT_EDITED_NOTIFICATION_TYPE = "game_result_edited";

export const GAME_RESULTS_UPLOAD_PATH = "/game-results-upload";

export function isEditedVideoRecord(row) {
	if (!row?.has_edited_file || !row.edited_file_path) return false;

	const editedType = String(row.edited_file_type || "").toLowerCase();
	if (editedType.startsWith("video")) return true;

	const extension = row.edited_file_path.split(".").pop()?.toLowerCase();
	const videoExtensions = new Set([
		"mp4",
		"webm",
		"mov",
		"avi",
		"mkv",
		"wmv",
		"flv",
		"m4v",
	]);
	return videoExtensions.has(extension);
}

export function buildEditedVideoNotification({
	gameName,
	contentName,
	gradeName,
}) {
	return {
		subject: "Your edited game video is ready",
		message: `Funmiyo team has uploaded an edited video for "${contentName || "your content"}" (${gameName || "game"}) in ${gradeName || "your class"}. Open Game Results to download or share it with parents.`,
		type: GAME_RESULT_EDITED_NOTIFICATION_TYPE,
	};

}

export function isEditedVideoNotification(notification) {
	return notification?.type === GAME_RESULT_EDITED_NOTIFICATION_TYPE;
}

export async function sendEditedVideoNotification(supabase, {
	senderId,
	recipientId,
	gameName,
	contentName,
	gradeName,
	gameResultId,
	academicYear,
	currentAcademicYear,
}) {
	if (
		academicYear &&
		currentAcademicYear &&
		normalizeAcademicYear(academicYear) !==
			normalizeAcademicYear(currentAcademicYear)
	) {
		return { ok: true, skipped: true };
	}

	const payload = buildEditedVideoNotification({
		gameName,
		contentName,
		gradeName,
	});

	if (gameResultId) {
		const { error: rpcError } = await supabase.rpc(
			"send_edited_video_notification",
			{
				p_game_result_id: gameResultId,
				p_sender_id: senderId,
			}
		);

		if (!rpcError) return { ok: true };
		if (
			rpcError.code !== "42883" &&
			!String(rpcError.message || "").includes(
				"send_edited_video_notification"
			)
		) {
			return { ok: false, error: rpcError };
		}
	}

	const { error } = await supabase.from("notifications").insert({
		sender_id: senderId,
		recipient_id: recipientId,
		subject: payload.subject,
		message: payload.message,
		type: payload.type,
		is_read: false,
		academic_year: academicYear || currentAcademicYear || null,
	});

	return error ? { ok: false, error } : { ok: true };
}
